module.exports = __webpack_public_path__ + "img/imageGalery4.5e8df495.jpg";